


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useHistory } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import Header from '../Components/Header';
// import Rightcontainer from '../Components/Rightcontainer';
// import Modal from 'react-bootstrap/Modal';
// import Spinner from 'react-bootstrap/Spinner';
// import { BsArrowRight, BsShieldCheck, BsLightningCharge, BsQrCodeScan, BsWallet2 } from 'react-icons/bs';

// const Addcase = ({ walletUpdate }) => {
//   const history = useHistory();
//   const access_token = localStorage.getItem('token');

//   const [amount, setAmount] = useState('');
//   const [step, setStep] = useState(1);
//   const [userAllData, setUserAllData] = useState(null);
//   const [upiList, setUpiList] = useState([]);
//   const [selectedUpi, setSelectedUpi] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [utr, setUtr] = useState('');
//   const [screenshot, setScreenshot] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [settinData, setSettinData] = useState(null);

//   // ✅ Premium Toast Configuration
//   const Toast = Swal.mixin({
//     toast: true,
//     position: 'top-end',
//     showConfirmButton: false,
//     timer: 3000,
//     timerProgressBar: true,
//     background: '#1e1e1e',
//     color: '#fff',
//     didOpen: (toast) => {
//       toast.addEventListener('mouseenter', Swal.stopTimer)
//       toast.addEventListener('mouseleave', Swal.resumeTimer)
//     }
//   });

//   useEffect(() => {
//     const setting = localStorage.getItem('sitSetting');
//     if (setting) setSettinData(JSON.parse(setting));
//   }, []);

//   useEffect(() => {
//     axios
//       .get('https://api.rrludo.in/me', { headers: { Authorization: `Bearer ${access_token}` } })
//       .then(res => setUserAllData(res.data))
//       .catch(e => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem('token');
//           window.location.reload();
//         }
//       });
//   }, [access_token]);

//   useEffect(() => {
//     const fetchUpi = async () => {
//       try {
//         const { data } = await axios.get('https://api.rrludo.in/upi/getUpiAll', {
//           headers: { Authorization: `Bearer ${access_token}` },
//         });
//         if (data.status) setUpiList(Array.isArray(data.data) ? data.data : [data.data]);
//       } catch {
//         Toast.fire({ icon: 'error', title: 'Failed to fetch UPI list' });
//       }
//     };
//     fetchUpi();
//   }, [access_token]);

//   const handleNext = () => {
//     const amt = Number(amount);
//     if (!amount || amt < settinData?.depositlimitMin) {
//       Toast.fire({ icon: 'warning', title: `Min ₹${settinData?.depositlimitMin} required` });
//       return;
//     }
//     if (amt > settinData?.depositlimitMax) {
//       Toast.fire({ icon: 'error', title: `Max limit is ₹${settinData?.depositlimitMax}` });
//       return;
//     }
//     setStep(2);
//   };

//   const handleFileChange = e => setScreenshot(e.target.files[0]);

//   const handleSubmitPayment = async () => {
//     if (!utr) {
//       Toast.fire({ icon: 'warning', title: 'UTR number is required' });
//       return;
//     }
//     setIsLoading(true);
//     try {
//       const formData = new FormData();
//       if (screenshot) formData.append('Transaction_Screenshot', screenshot);
//       formData.append('amount', amount);
//       formData.append('referenceId', utr);

//       const { data } = await axios.post(
//         'https://api.rrludo.in/manual/deposit/txn',
//         formData,
//         { headers: { Authorization: `Bearer ${access_token}` } }
//       );

//       setIsLoading(false);
//       Toast.fire({ 
//         icon: data.status === 'Pending' ? 'success' : 'error', 
//         title: data.message 
//       });

//       if(data.status === 'Pending') {
//         walletUpdate();
//         setShowModal(false);
//         setStep(1);
//         setAmount('');
//         setUtr('');
//         setScreenshot(null);
//         setSelectedUpi(null);
//       }
//     } catch {
//       setIsLoading(false);
//       Toast.fire({ icon: 'error', title: 'Submission failed' });
//     }
//   };

//   const filteredUpiList = upiList.filter(upi => Number(amount) >= upi.limitFrom && Number(amount) <= upi.limitTo);
//   const gatewayUpi = upiList.find(upi => Number(amount) >= upi.gatewayMin && Number(amount) <= upi.gatewayMax);

//   const handleZapGateway = async () => {
//     if (!amount) return;
//     try {
//       const { data } = await axios.get(`https://api.rrludo.in/zapupi-request?amount=${amount}`, {
//         headers: { Authorization: `Bearer ${access_token}` },
//       });
//       if (data.status && data.payment_url) {
//         Toast.fire({ icon: 'info', title: 'Redirecting to Gateway...' });
//         setTimeout(() => window.open(data.payment_url, '_blank'), 1000);
//       } else {
//         Toast.fire({ icon: 'error', title: data.msg || 'Gateway Error' });
//       }
//     } catch {
//       Toast.fire({ icon: 'error', title: 'Connection Failed' });
//     }
//   };

//   const handleIMBGateway = async () => {
//     if (!amount || amount <= 0) return;
//     try {
//       const res = await axios.get(`https://api.rrludo.in/imb-request?amount=${amount}`, {
//         headers: { Authorization: `Bearer ${access_token}` },
//       });
//       if (res.data?.status === true && res.data?.payment_url) {
//         Toast.fire({ icon: 'info', title: 'Connecting Gateway...' });
//         setTimeout(() => window.location.href = res.data.payment_url, 1200);
//       } else {
//         Toast.fire({ icon: 'error', title: res.data?.msg || "Order Failed" });
//       }
//     } catch {
//       Toast.fire({ icon: 'error', title: "Gateway Connection Failed" });
//     }
//   };

//   const handlePayQr = upi => {
//     setSelectedUpi(upi);
//     setStep(3);
//   };

//   const styles = {
//     pageBg: {
//       background: 'radial-gradient(circle at top, #1a1a1a, #0a0a0a)',
//       minHeight: '100vh',
//       paddingTop: '20px',
//       color: '#fff',
//       fontFamily: "'Inter', sans-serif"
//     },
//     glassCard: {
//       background: 'rgba(30, 30, 30, 0.5)',
//       backdropFilter: 'blur(15px)',
//       borderRadius: '28px',
//       border: '1px solid rgba(255,255,255,0.05)',
//       padding: '35px 25px',
//       boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
//       textAlign: 'center'
//     },
//     stepIndicator: {
//       display: 'flex',
//       justifyContent: 'center',
//       gap: '8px',
//       marginBottom: '25px'
//     },
//     stepDot: (active) => ({
//       width: '40px',
//       height: '6px',
//       borderRadius: '10px',
//       background: active ? '#FF3131' : '#222',
//       transition: 'all 0.4s ease'
//     }),
//     inputBox: {
//       background: '#121212',
//       borderRadius: '18px',
//       border: '1.5px solid #333',
//       display: 'flex',
//       alignItems: 'center',
//       padding: '15px 20px',
//       marginBottom: '10px'
//     },
//     chip: {
//       background: '#1e1e1e',
//       border: '1px solid #333',
//       borderRadius: '14px',
//       padding: '12px',
//       color: '#fff',
//       fontWeight: '700',
//       cursor: 'pointer',
//       flex: '1',
//       margin: '5px',
//       transition: '0.2s'
//     },
//     primaryBtn: {
//       background: 'linear-gradient(180deg, #FF3131 0%, #BA0000 100%)',
//       border: 'none',
//       borderRadius: '18px',
//       padding: '18px',
//       color: '#fff',
//       fontWeight: '800',
//       width: '100%',
//       fontSize: '16px',
//       letterSpacing: '1px',
//       boxShadow: '0 10px 20px rgba(186,0,0,0.3)',
//       marginTop: '20px'
//     },
//     methodBox: {
//       background: '#161616',
//       borderRadius: '22px',
//       border: '1px solid #d71010',
//       padding: '20px',
//       width: '100%',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '15px',
//       color: '#fff',
//       cursor: 'pointer',
//       transition: '0.3s'
//     }
//   };

//   return (
//     <>
//       <Header user={userAllData} />
//       <div style={styles.pageBg}>
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-lg-6 col-md-10">
              
//               <div style={styles.stepIndicator}>
//                   <div style={styles.stepDot(step >= 1)}></div>
//                   <div style={styles.stepDot(step >= 2)}></div>
//                   <div style={styles.stepDot(step >= 3)}></div>
//               </div>

//               <div style={styles.glassCard}>
//                 {step === 1 && (
//                   <>
//                     <BsWallet2 size={40} color="#FF3131" className="mb-3" />
//                     <h4 className="fw-bold mb-4">Add Cash to Wallet</h4>
//                     <div style={styles.inputBox}>
//                       <span style={{fontSize: '22px', fontWeight: '800', color: '#4CAF50', marginRight: '15px'}}>₹</span>
//                       <input
//                         type="tel"
//                         value={amount}
//                         onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))}
//                         placeholder="Enter Amount"
//                         style={{background: 'transparent', border: 'none', color: '#fff', fontSize: '24px', fontWeight: '700', width: '100%', outline: 'none'}}
//                       />
//                     </div>
                    
//                     <div className="d-flex justify-content-between px-2 mb-4">
//                       <small style={{color: '#666'}}>Min: ₹{settinData?.depositlimitMin}</small>
//                       <small style={{color: '#666'}}>Max: ₹{settinData?.depositlimitMax}</small>
//                     </div>

//                     <div className="d-flex flex-wrap mb-2">
//                       {[100, 500, 1000, 2000].map(v => (
//                         <button key={v} onClick={() => setAmount(v)} style={styles.chip}>{v}</button>
//                       ))}
//                     </div>

//                     <button style={styles.primaryBtn} onClick={handleNext}>
//                       PROCEED <BsArrowRight style={{marginLeft: '10px'}} />
//                     </button>
//                   </>
//                 )}

//                 {step === 2 && (
//                   <>
//                     <h4 className="fw-bold mb-4">Payment Method</h4>
//                     <div className="mb-4 p-3" style={{background: '#121212', borderRadius: '15px', border: '1px dashed #c72121'}}>
//                         <small style={{color: '#888'}}>TOTAL PAYABLE</small>
//                         <h2 className="fw-bold mb-0">₹{amount}</h2>
//                     </div>

//                     {settinData?.isImbpGateway && gatewayUpi && (
//                       <div style={styles.methodBox} onClick={handleIMBGateway}>
//                         <div className="d-flex align-items-center">
//                           <BsLightningCharge color="#FFD700" size={24} className="me-3" />
//                           <div className="text-start">
//                             <h6 className="mb-0 fw-bold">Instant Add</h6>
//                             <small style={{color: '#555'}}>Auto-approval gateway</small>
//                           </div>
//                         </div>
//                         <BsArrowRight color="#444" />
//                       </div>
//                     )}

//                     {settinData?.isManualDeposit && filteredUpiList.length > 0 && filteredUpiList.map(upi => (
//                       <div key={upi._id} style={styles.methodBox} onClick={() => handlePayQr(upi)}>
//                         <div className="d-flex align-items-center">
//                           <BsQrCodeScan color="#FF3131" size={22} className="me-3" />
//                           <div className="text-start">
//                             <h6 className="mb-0 fw-bold">Manual QR</h6>
//                             <small style={{color: '#555'}}>Verification required</small>
//                           </div>
//                         </div>
//                         <BsArrowRight color="#444" />
//                       </div>
//                     ))}

//                     <button className="btn btn-link w-100 mt-2" style={{color: '#555', textDecoration: 'none'}} onClick={() => setStep(1)}>
//                       Edit Amount
//                     </button>
//                   </>
//                 )}

//                 {step === 3 && selectedUpi && (
//                   <>
//                     <h4 className="fw-bold mb-3">Scan & Pay</h4>
//                     <div style={{background: '#fff', padding: '15px', borderRadius: '22px', display: 'inline-block', marginBottom: '20px'}}>
//                         <img src={`https://api.rrludo.in${selectedUpi.qrImage}`} alt="QR" style={{width: '200px', height: '200px', objectFit: 'contain'}} />
//                     </div>

//                     <div className="d-flex align-items-center justify-content-between p-3 mb-4" style={{background: '#121212', borderRadius: '14px', border: '1px dashed #444'}}>
//                         <span style={{fontSize: '14px', fontWeight: '600'}}>{selectedUpi.upiId}</span>
//                         <button className="btn btn-sm btn-danger px-3 rounded-pill" onClick={() => {
//                             navigator.clipboard.writeText(selectedUpi.upiId);
//                             Toast.fire({ icon: 'success', title: 'UPI ID Copied' });
//                         }}>Copy</button>
//                     </div>

//                     <button style={styles.primaryBtn} onClick={() => setShowModal(true)}>
//                       UPLOAD PAYMENT PROOF
//                     </button>
//                     <button className="btn btn-link w-100 mt-2" style={{color: '#555'}} onClick={() => setStep(2)}>Go Back</button>
//                   </>
//                 )}
//               </div>

//               <div className="text-center mt-5" style={{opacity: '0.4'}}>
//                   <BsShieldCheck size={18} color="#4CAF50" className="me-2" />
//                   <small style={{fontSize: '11px', letterSpacing: '1px'}}>SECURE 256-BIT ENCRYPTED TRANSACTIONS</small>
//               </div>
//             </div>

//             <div className="col-lg-4 d-none d-lg-block">
//               <Rightcontainer />
//             </div>
//           </div>
//         </div>
//       </div>

//       <Modal show={showModal} onHide={() => setShowModal(false)} centered contentClassName="dark-modal">
//         <div style={{background: '#1e1e1e', borderRadius: '30px', border: '1px solid #333', padding: '30px', color: '#fff'}}>
//           <Modal.Header closeButton className="border-0 p-0 mb-4">
//             <Modal.Title className="w-100 text-center fw-bold">Submit Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="p-0">
//             <label className="small mb-2 text-muted">UTR / Transaction ID (12 Digits)</label>
//             <input
//               type="text"
//               className="form-control mb-3"
//               placeholder="Enter 12 digit UTR"
//               value={utr}
//               onChange={e => setUtr(e.target.value)}
//               style={{background: '#121212', border: '1px solid #333', color: '#fff', borderRadius: '14px', padding: '12px'}}
//             />
            
//             <label className="small mb-2 text-muted">Upload Screenshot (Optional)</label>
//             <input
//               type="file"
//               className="form-control mb-4"
//               accept="image/*"
//               onChange={handleFileChange}
//               style={{background: '#121212', border: '1px solid #333', color: '#fff', borderRadius: '14px', padding: '12px'}}
//             />

//             <button style={styles.primaryBtn} onClick={handleSubmitPayment} disabled={isLoading}>
//               {isLoading ? <Spinner animation="border" size="sm" /> : "CONFIRM PAYMENT"}
//             </button>
//           </Modal.Body>
//         </div>
//       </Modal>

//       <style>{`
//         .dark-modal .btn-close { filter: invert(1) brightness(2); }
//         .modal-content { background: transparent; border: none; }
//         .form-control:focus { background: #121212; color: #fff; border-color: #FF3131; box-shadow: none; }
//       `}</style>
//     </>
//   );
// };

// export default Addcase;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../Components/Header';
import Rightcontainer from '../Components/Rightcontainer';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { BsArrowRight, BsShieldCheck, BsLightningCharge, BsQrCodeScan, BsWallet2, BsCheckCircleFill } from 'react-icons/bs';
import { MdOutlineSecurity } from 'react-icons/md';

const Addcase = ({ walletUpdate }) => {
    const history = useHistory();
    const access_token = localStorage.getItem('token');

    const [amount, setAmount] = useState('');
    const [step, setStep] = useState(1);
    const [userAllData, setUserAllData] = useState(null);
    const [upiList, setUpiList] = useState([]);
    const [selectedUpi, setSelectedUpi] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [utr, setUtr] = useState('');
    const [screenshot, setScreenshot] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [settinData, setSettinData] = useState(null);

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        background: '#000',
        color: '#FF9800',
    });

    useEffect(() => {
        const setting = localStorage.getItem('sitSetting');
        if (setting) setSettinData(JSON.parse(setting));
    }, []);

    useEffect(() => {
        axios
            .get('https://api.rrludo.in/me', { headers: { Authorization: `Bearer ${access_token}` } })
            .then(res => setUserAllData(res.data))
            .catch(e => {
                if (e.response?.status === 401) {
                    localStorage.removeItem('token');
                    window.location.reload();
                }
            });
    }, [access_token]);

    useEffect(() => {
        const fetchUpi = async () => {
            try {
                const { data } = await axios.get('https://api.rrludo.in/upi/getUpiAll', {
                    headers: { Authorization: `Bearer ${access_token}` },
                });
                if (data.status) setUpiList(Array.isArray(data.data) ? data.data : [data.data]);
            } catch {
                Toast.fire({ icon: 'error', title: 'Failed to fetch UPI list' });
            }
        };
        fetchUpi();
    }, [access_token]);

    const handleNext = () => {
        const amt = Number(amount);
        if (!amount || amt < settinData?.depositlimitMin) {
            Toast.fire({ icon: 'warning', title: `Min ₹${settinData?.depositlimitMin} required` });
            return;
        }
        if (amt > settinData?.depositlimitMax) {
            Toast.fire({ icon: 'error', title: `Max limit is ₹${settinData?.depositlimitMax}` });
            return;
        }
        setStep(2);
    };

    const handleFileChange = e => setScreenshot(e.target.files[0]);

    const handleSubmitPayment = async () => {
        if (!utr) {
            Toast.fire({ icon: 'warning', title: 'UTR number is required' });
            return;
        }
        setIsLoading(true);
        try {
            const formData = new FormData();
            if (screenshot) formData.append('Transaction_Screenshot', screenshot);
            formData.append('amount', amount);
            formData.append('referenceId', utr);

            const { data } = await axios.post(
                'https://api.rrludo.in/manual/deposit/txn',
                formData,
                { headers: { Authorization: `Bearer ${access_token}` } }
            );

            setIsLoading(false);
            Toast.fire({
                icon: data.status === 'Pending' ? 'success' : 'error',
                title: data.message
            });

            if (data.status === 'Pending') {
                walletUpdate();
                setShowModal(false);
                setStep(1);
                setAmount('');
                setUtr('');
                setScreenshot(null);
                setSelectedUpi(null);
            }
        } catch {
            setIsLoading(false);
            Toast.fire({ icon: 'error', title: 'Submission failed' });
        }
    };

    const filteredUpiList = upiList.filter(upi => Number(amount) >= upi.limitFrom && Number(amount) <= upi.limitTo);
    const gatewayUpi = upiList.find(upi => Number(amount) >= upi.gatewayMin && Number(amount) <= upi.gatewayMax);

    const handlePayQr = upi => {
        setSelectedUpi(upi);
        setStep(3);
    };

    const handleIMBGateway = async () => {
        if (!amount || amount <= 0) return;
        try {
            const res = await axios.get(`https://api.rrludo.in/imb-request?amount=${amount}`, {
                headers: { Authorization: `Bearer ${access_token}` },
            });
            if (res.data?.status === true && res.data?.payment_url) {
                Toast.fire({ icon: 'info', title: 'Connecting Gateway...' });
                setTimeout(() => window.location.href = res.data.payment_url, 1200);
            } else {
                Toast.fire({ icon: 'error', title: res.data?.msg || "Order Failed" });
            }
        } catch {
            Toast.fire({ icon: 'error', title: "Gateway Connection Failed" });
        }
    };

    const styles = {
        wrapper: {
            background: '#FFFDE7',
            minHeight: '100vh',
            // paddingTop: '80px',
            fontFamily: "'Poppins', sans-serif",
        },
        stepperContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 40px',
            background: '#000',
            borderRadius: '0 0 30px 30px',
            marginBottom: '30px',
            position: 'relative'
        },
        stepCircle: (active, completed) => ({
            width: '35px',
            height: '35px',
            borderRadius: '50%',
            background: completed ? '#FF9800' : active ? '#FF9800' : '#333',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: active || completed ? '#000' : '#888',
            fontWeight: '800',
            fontSize: '14px',
            zIndex: 2,
            border: active ? '3px solid #FFFDE7' : 'none'
        }),
        contentCard: {
            background: '#fff',
            borderRadius: '30px',
            padding: '30px 20px',
            margin: '0 15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
            border: '1px solid #FFF9C4',
            textAlign: 'center'
        },
        amountInputArea: {
            background: '#F5F5F5',
            borderRadius: '20px',
            padding: '15px 20px',
            display: 'flex',
            alignItems: 'center',
            margin: '20px 0 10px 0',
            border: '2px solid transparent',
        },
        chip: {
            background: '#000',
            color: '#FF9800',
            borderRadius: '12px',
            padding: '12px 5px',
            fontSize: '15px',
            fontWeight: '800',
            border: 'none',
            width: '100%', // Ensure it fills the column
            transition: '0.2s'
        },
        btnPrimary: {
            background: '#000',
            color: '#FF9800',
            border: 'none',
            borderRadius: '15px',
            padding: '18px',
            width: '100%',
            fontWeight: '800',
            fontSize: '16px',
            marginTop: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
        },
        methodCard: {
            background: '#fff',
            borderRadius: '20px',
            padding: '15px 20px',
            marginBottom: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: '2px solid #F0E68C',
            cursor: 'pointer'
        }
    };

    return (
        <>
            <Header user={userAllData} />
            <div style={styles.wrapper}>
                <div className="container p-0">
                    <div className="row justify-content-center m-0">
                        <div className="col-12 col-md-8 col-lg-5 p-0">
                            
                            <div style={styles.stepperContainer}>
                                <div style={{position: 'absolute', top: '50%', left: '10%', right: '10%', height: '2px', background: '#333', zIndex: 1}}></div>
                                <div style={styles.stepCircle(step === 1, step > 1)}>{step > 1 ? <BsCheckCircleFill size={20}/> : "1"}</div>
                                <div style={styles.stepCircle(step === 2, step > 2)}>{step > 2 ? <BsCheckCircleFill size={20}/> : "2"}</div>
                                <div style={styles.stepCircle(step === 3, step > 3)}>{step > 3 ? <BsCheckCircleFill size={20}/> : "3"}</div>
                            </div>

                            <div style={styles.contentCard}>
                                {step === 1 && (
                                    <>
                                        <BsWallet2 size={45} color="#FF9800" />
                                        <h3 className="fw-bold mt-3">Add Money</h3>
                                        <p style={{color: '#888', fontSize: '12px'}}>Enter the amount you want to add to your chips</p>
                                        
                                        <div style={styles.amountInputArea}>
                                            <span style={{fontSize: '28px', fontWeight: '900', color: '#000', marginRight: '10px'}}>₹</span>
                                            <input
                                                type="tel"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))}
                                                placeholder="0.00"
                                                style={{background: 'transparent', border: 'none', width: '100%', outline: 'none', fontSize: '32px', fontWeight: '900'}}
                                            />
                                        </div>

                                        <div className="mb-3 text-start px-2">
                                            <small style={{color: '#999', fontWeight: '700'}}>QUICK SELECT</small>
                                        </div>

                                        {/* FIXED GRID LAYOUT FOR BUTTONS */}
                                        <div className="row g-2 mb-4">
                                            {[100, 500, 1000, 2000].map(v => (
                                                <div className="col-6 col-sm-3" key={v}>
                                                    <button className='mt-3' onClick={() => setAmount(v)} style={styles.chip}>+ ₹{v}</button>
                                                </div>
                                            ))}
                                        </div>

                                        <button style={styles.btnPrimary} onClick={handleNext}>
                                            CONTINUE TO PAY <BsArrowRight />
                                        </button>
                                    </>
                                )}

                                {step === 2 && (
                                    <>
                                        <h4 className="fw-bold text-start mb-4">Select Method</h4>
                                        {settinData?.isImbpGateway && gatewayUpi && (
                                            <div style={styles.methodCard} onClick={handleIMBGateway}>
                                                <div className="d-flex align-items-center gap-3">
                                                    <div style={{background: '#000', padding: '10px', borderRadius: '12px'}}>
                                                        <BsLightningCharge color="#FF9800" size={20} />
                                                    </div>
                                                    <div className="text-start">
                                                        <h6 className="mb-0 fw-bold">Instant Gateway</h6>
                                                        <small className="text-success fw-bold" style={{fontSize: '10px'}}>AUTO CREDIT • FAST</small>
                                                    </div>
                                                </div>
                                                <BsArrowRight color="#FF9800" />
                                            </div>
                                        )}

                                        {settinData?.isManualDeposit && filteredUpiList.map(upi => (
                                            <div key={upi._id} style={styles.methodCard} onClick={() => handlePayQr(upi)}>
                                                <div className="d-flex align-items-center gap-3">
                                                    <div style={{background: '#FF9800', padding: '10px', borderRadius: '12px'}}>
                                                        <BsQrCodeScan color="#000" size={20} />
                                                    </div>
                                                    <div className="text-start">
                                                        <h6 className="mb-0 fw-bold">Scan QR Manual</h6>
                                                        <small style={{fontSize: '10px', color: '#888'}}>5-10 MINS APPROVAL</small>
                                                    </div>
                                                </div>
                                                <BsArrowRight color="#888" />
                                            </div>
                                        ))}

                                        <button className="btn w-100 mt-3 fw-bold" style={{color: '#888', fontSize: '13px'}} onClick={() => setStep(1)}>
                                            ← Change Amount
                                        </button>
                                    </>
                                )}

                                {step === 3 && selectedUpi && (
                                    <>
                                        <h4 className="fw-bold mb-4">Scan to Pay</h4>
                                        <div style={{background: '#000', padding: '20px', borderRadius: '25px', display: 'inline-block', marginBottom: '20px'}}>
                                            <img src={`https://api.rrludo.in${selectedUpi.qrImage}`} alt="QR" style={{width: '200px', borderRadius: '15px'}} />
                                        </div>

                                        <div className="p-3 mb-4" style={{background: '#FFFDE7', borderRadius: '15px', border: '2px dashed #FF9800'}}>
                                            <small className="d-block text-muted fw-bold">UPI ADDRESS</small>
                                            <span className="fw-bold fs-5">{selectedUpi.upiId}</span>
                                            <button className="btn btn-dark btn-sm ms-2 px-3" style={{borderRadius: '10px', color: '#FF9800'}} onClick={() => {
                                                navigator.clipboard.writeText(selectedUpi.upiId);
                                                Toast.fire({ icon: 'success', title: 'Copied!' });
                                            }}>COPY</button>
                                        </div>

                                        <button style={styles.btnPrimary} onClick={() => setShowModal(true)}>
                                            SUBMIT REFERENCE ID
                                        </button>
                                    </>
                                )}
                            </div>

                            <div className="text-center mt-5 mb-5" style={{opacity: 0.6}}>
                                <MdOutlineSecurity size={20} color="#2E7D32" className="me-2" />
                                <small style={{fontSize: '11px', fontWeight: '800', letterSpacing: '1px'}}>SECURE SSL ENCRYPTED PAYMENT</small>
                            </div>
                        </div>

                        <div className="col-lg-4 d-none d-lg-block">
                            <Rightcontainer />
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <div style={{background: '#fff', borderRadius: '30px', padding: '30px', border: '4px solid #000'}}>
                    <Modal.Header closeButton className="border-0 p-0 mb-3">
                        <Modal.Title className="fw-black">Final Step</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <div className="mb-3">
                            <label className="small fw-bold mb-2">12 Digit UTR / Reference No.</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Example: 3094..."
                                value={utr}
                                onChange={e => setUtr(e.target.value)}
                                style={{borderRadius: '12px', padding: '12px', border: '2px solid #000', fontWeight: '700'}}
                            />
                        </div>
                        
                        <div className="mb-4">
                            <label className="small fw-bold mb-2">Upload Proof (Optional)</label>
                            <input
                                type="file"
                                className="form-control"
                                onChange={handleFileChange}
                                style={{borderRadius: '12px', border: '1px solid #ddd'}}
                            />
                        </div>

                        <button style={styles.btnPrimary} onClick={handleSubmitPayment} disabled={isLoading}>
                            {isLoading ? <Spinner animation="border" size="sm" /> : "COMPLETE DEPOSIT"}
                        </button>
                    </Modal.Body>
                </div>
            </Modal>
        </>
    );
};

export default Addcase;